import React, { useState, useEffect } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { FaEnvelope, FaUser } from 'react-icons/fa';
import LanguageSwitcher from '../languageSwitcher';
import CurrencySwitcher from '../currencySwitcher';
import logoIcon from '../../assets/img/logo.svg';
import './header.scss';

function Header() {
    const location = useLocation();
    const [expanded, setExpanded] = useState(false);
    const [sticky, setSticky] = useState(false);
    const { i18n, t } = useTranslation();
    const currentLanguage = i18n.language;
    const isFR = currentLanguage === 'fr';
    const isTermsPage = location.pathname.includes(`${currentLanguage}/terms`);

    const localizedPath = (path) => {
        const baseLangUrl = `/${currentLanguage}`;
        return baseLangUrl + path;
    };

    const handleNavClick = () => {
        setExpanded(false);
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        const handleScroll = () => {
            const isSticky = window.scrollY > 40;
            setSticky(isSticky);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <header
            className={`header-wrapper${` ${currentLanguage}`}${isTermsPage ? ' terms-header' : ''}${sticky ? ' sticky-header' : ''}`}
        >
            <div className="header-top">
                <Container>
                    <LanguageSwitcher />
                    <CurrencySwitcher />
                    <Nav className="header-top-menu">
                        <NavLink
                            onClick={handleNavClick}
                            to={localizedPath('/contact')}
                            className="nav-link"
                        >
                            <FaEnvelope size={15} className="d-inline-block" alt="Contact us" />
                            {t('header.contact-us')}
                        </NavLink>
                        <Nav.Link
                            onClick={handleNavClick}
                            href={`https://obambu.com/my/clientarea.php?language=${isFR ? 'french' : 'english'}&amp;systpl=${isFR ? 'fr' : 'en'}`}
                            rel="noopener noreferrer"
                        >
                            <FaUser size={15} className="d-inline-block" alt="Sign in" />
                            {t('header.sign-in')}
                        </Nav.Link>
                    </Nav>
                </Container>
            </div>
            <Navbar
                expanded={expanded}
                expand="lg"
                className={`menu-wrapper ${expanded ? 'navbar-expanded' : ''}`}
            >
                <Container>
                    <NavLink
                        to={localizedPath('/')}
                        onClick={handleNavClick}
                        className="navbar-brand"
                    >
                        <img
                            src={logoIcon}
                            width="172"
                            height="36"
                            className="d-inline-block align-top"
                            alt="Logo"
                        />
                    </NavLink>
                    <Navbar.Toggle
                        aria-controls="basic-navbar-nav"
                        onClick={() => setExpanded(!expanded)}
                        aria-expanded={expanded}
                    />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav>
                            <NavLink
                                onClick={handleNavClick}
                                to={localizedPath('/')}
                                className="nav-link"
                                end
                            >
                                {t('header.home')}
                            </NavLink>
                            <NavLink
                                onClick={handleNavClick}
                                to={localizedPath('/hosting/web')}
                                className="nav-link"
                            >
                                {t('header.web-hosting')}
                            </NavLink>
                            <NavLink
                                onClick={handleNavClick}
                                to={localizedPath('/domain-name')}
                                className="nav-link"
                            >
                                {t('header.domain-name')}
                            </NavLink>
                            <NavLink
                                onClick={handleNavClick}
                                to={localizedPath('/professional-business-email')}
                                className="nav-link"
                            >
                                {t('header.email')}
                            </NavLink>
                            <NavLink
                                onClick={handleNavClick}
                                to={localizedPath('/vps-server')}
                                className="nav-link"
                            >
                                VPS
                            </NavLink>
                            <NavLink
                                onClick={handleNavClick}
                                to={localizedPath('/hosting/reseller')}
                                className="nav-link"
                            >
                                {t('header.reseller-hosting')}
                            </NavLink>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
}

export default Header;
